// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrapper":"BreadcrumbContainer_breadcrumbWrapper__XFPtF"};